var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._l((_vm.matches),function(match,index){return [_c('span',{key:index,class:_vm.classes(match.context, 'text')},[_vm._v(_vm._s(_vm.getText(match)))]),(index !== _vm.matches.length - 1)?[_vm._v(",\n    ")]:_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }